var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-details" }, [
    _c("h4", [_vm._v("Detalhes do agendamento")]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n    Limpeza de "),
      _c("span", [_vm._v(_vm._s(_vm._f("getOrderDuration")(_vm.payable)))]),
      _vm._v(" no dia "),
      _c("span", [_vm._v(_vm._s(_vm._f("getOrderScheduleDay")(_vm.payable)))]),
      _vm._v(" com o(a) profissional "),
      _c("span", [
        _vm._v(_vm._s(_vm._f("getOrderProfessionalFullName")(_vm.payable)))
      ]),
      _vm._v(" no endereço "),
      _c("span", [_vm._v(_vm._s(_vm._f("getOrderAddressName")(_vm.payable)))]),
      _vm._v(".\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "amount" }, [
      _vm._v(_vm._s(_vm._f("getOrderAmount")(_vm.payable)))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28f6f8c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28f6f8c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/CheckoutMobile/Payable/OrderComponents/OrderDetails.vue
// module id = null
// module chunks = 